export const usePageRedirects = () => {
  const showErrorPage = (error: ApiResponseError, statusCode = 503) => {
    throw createError({
      statusCode: statusCode,
      message: error.message,
      fatal: true,
    })
  }

  const redirectDeletedPage = async (province: string) => {
    await navigateTo(routes().cottageProvince({ slug: province }), {
      external: true,
      redirectCode: 301,
    })
  }

  return {
    showErrorPage,
    redirectDeletedPage,
  }
}
